export const stylesMap = {
  'Mapbox Streets': 'streets',
  'Mapbox Satellite Streets': 'satellite-streets',
  'Mapbox Light': 'light',
  'Mapbox Dark': 'dark',
  Scenic: 'scenic',
};
